<template>
  <div class="parcel">
    <div class="weui-cells">
      <div @click="cascadePicker" class="weui-cell weui-cell_select weui-cell_select-after">
        <div class="weui-cell__hd bg1">
          <label class="weui-label fz30">区域选择</label>
        </div>
        <div class="weui-cell__bd tar pr50">
          <span v-if="address_full" class=" fz30">{{address_full}}</span>
          <span v-else class="c_999 fz30">请选择</span>
        </div>
      </div>
      <!-- {{info}} -->
      <div @click="chooseService" class="weui-cell weui-cell_select weui-cell_select-after">
        <div class="weui-cell__hd bg2">
          <label class="weui-label fz30">服务商</label>
        </div>
        <div class="weui-cell__bd tar pr50">
          <span v-if="service_title" class="fz30">{{service_title}}</span>
          <span v-else class="c_999 fz30">请选择</span>
        </div>
      </div>
    </div>
    <div class="mt16"></div>
    <div class="weui-cells">
      <div class="weui-cell">
        <div class="weui-cell__hd bg3">
          <label class="weui-label fz30">取件地址</label>
        </div>
      </div>
      <div class="weui-cell">
        <div class="weui-cell__bd pt20 pl24 pr24">
          <textarea v-model="note" class="weui-textarea fz30" placeholder="上门服务四件起，请填写详细取件地址" rows="4" maxlength="100"></textarea>
        </div>
      </div>
    </div>

    <!-- <div class="app-btn-area weui-btn-area">
        <div @click="submit" class="weui-btn">确认</div>
    </div> -->
    <div class="mt80"></div>

    <div @click="setval" v-if="show" class="mb20 ml24 mr24 b_vip3 c_fff tac bdrd50 fz30 lh80">最近填写过的地址</div>
    <div @click="submit" class="ml24 mr24 b_red c_fff tac bdrd50 fz30 lh80">确认</div>

    <div id="singleLinePicker"></div>
    <div id="singleLinePicker2"></div>

    <footbottom></footbottom>

    <transition name="fade">
      <message v-if="successPopShow" :time="3000" @myevent="myevent">
        <div class="fz28 c_333 mt10">提交成功</div>
        <div class="fz28 c_999">正在处理中，请保持电话畅通</div>
      </message>
    </transition>
  </div>
</template>
<script>
import weui from 'weui.js'
import footbottom from '@/footer'
import message from '@/components/message'
export default {
  components: {
    footbottom, message
  },
  props: {
    islogin: Boolean,
  },
  data() {
    return {
      addList: [],
      add_id: '',
      serviceList: [],

      note: '',

      info: {},
      service_id: '',
      service_title: '',
      province_id: '',
      province_title: '',
      city_id: '',
      city_title: '',
      district_id: '',
      district_title: '',
      note: '',

      address_full: '',
      provinceList: [],
      provinceListStr: '',
      address_value: ['', '', ''],

      successPopShow: false,

      show: false
    }
  },
  created() {
    if (this.islogin == true) {
      this.getAccount();
    }
  },
  watch: {
    'islogin'() {
      if (this.islogin == true) {
        this.getAccount();
      }
    },
    "provinceListStr"() {
      this.show = this.provinceList.length > 0 && this.info.province_id;
    }
  },
  methods: {
    myevent(e) {
      if (e.close) {
        this.successPopShow = false;
      }
    },
    getAccount() {
      let vm = this;
      vm.ajax("account", "get", '', e => {
        vm.account = e.data;
        vm.getInfo()
      })
    },
    getInfo() {
      let vm = this;
      vm.ajax("account/parcel", "get", '', e => {
        if (e.data) {
          vm.info = e.data;
        }
        vm.getArea();
        // vm.getService();
      })
    },
    cascadePicker() {
      let vm = this;
      // console.log(vm.provinceList)
      if (vm.provinceList.length <= 0) {
        vm.publics.message.danger('正在加载中，请稍后再试！');
        return false;
      }
      weui.picker(vm.provinceList, {
        // className: 'cascadePicker',
        container: 'body',
        depth: 3,
        defaultValue: vm.address_value,
        // onChange: function (result) {
        //     //console.log('onChange',result)
        // },
        onConfirm: function (result) {
          // province_id:1,
          // city_id:1,
          // district_id:1,
          // //console.log(result)
          if (result[0]) {
            vm.province_id = result[0].value;
            vm.province_title = result[0].label;
            vm.address_value[0] = result[0].value;
          }
          if (result[1]) {
            vm.city_id = result[1].value;
            vm.city_title = result[1].label;
            vm.address_value[1] = result[1].value;
          }
          if (result[2]) {
            vm.district_id = result[2].value;
            vm.district_title = result[2].label;
            vm.address_value[2] = result[2].value;
          }
          vm.address_full = result[0].label + result[1].label + result[2].label

          vm.getService();
        },
        id: new Date().getTime()
      });
    },
    getArea() {
      let vm = this;
      //   console.log('app.area',app.area)
      if (app.area) {
        vm.getProvinceList(app.area);
      } else {
        vm.getAreaApi();
      }
    },
    getAreaApi() {
      let vm = this;
      vm.ajax("area", "get", '', e => {
        vm.getProvinceList(e.data);
      })
    },
    getProvinceList(data) {
      let vm = this;
      data.forEach((v1, k1) => {
        // console.log('v1,k1',v1,k1)
        let arr2 = [];
        if (v1.list && v1.list.length > 0) {
          v1.list.forEach((v2, k2) => {
            // console.log('v2,k2',v2,k2)
            let arr3 = [];
            if (v2.list && v2.list.length > 0) {
              v2.list.forEach((v3, k3) => {
                // console.log('v3,k3',v3,k3)
                arr3[k3] = {
                  label: v3.title,
                  value: v3.id
                }

              })
            }
            arr2[k2] = {
              label: v2.title,
              value: v2.id,
              children: arr3
            }

          });
        }
        vm.provinceList[k1] = {
          label: v1.title,
          value: v1.id,
          children: arr2
        };
        vm.provinceListStr = JSON.stringify(vm.province_title);
        vm.address_value = [data[0].id, data[0].list[0].id, data[0].list[0].list[0].id]

      });
    },

    chooseService() {
      let vm = this;
      if (!(vm.district_id > 0)) {
        vm.publics.message.danger('请选择区域');
        return false;
      }
      if (vm.serviceList.length <= 0) {
        vm.publics.message.danger('所选区域未开通服务');
        return false;
      }
      let defaultValue = vm.serviceList[0].value;
      if (vm.service_id > 0) {
        defaultValue = vm.service_id
      }
      // console.log(vm.service_id,defaultValue)
      weui.picker(vm.serviceList, {
        className: 'custom-classname',
        container: 'body',
        defaultValue: [defaultValue],
        // onChange: function (result) {
        //     console.log('onChange',result)
        // },
        onConfirm: function (result) {
          vm.service_id = result[0].value;
          vm.service_title = result[0].label;
        },
        id: 'singleLinePicker2' + new Date().getTime()
      });
    },
    getService() {
      let vm = this;
      let data = "page=1&limit=100000"
      data += "&province_id=" + vm.province_id;
      data += "&city_id=" + vm.city_id;
      data += "&district_id=" + vm.district_id;
      vm.ajax("service", "get", data, e => {
        if (e.data.list && e.data.list.length > 0) {
          vm.serviceList = e.data.list;
          vm.serviceList.map((v, k) => {
            v.label = v.title
            v.value = v.id
            // console.log(vm.service_id,v.id)
            if (vm.service_id && vm.service_id == v.id) {
              vm.service_title = v.title
            }
          })
        } else {
          vm.serviceList = []
          vm.service_id = ''
          vm.service_title = ''
        }
      })
    },

    setval() {
      let vm = this;
      if (vm.provinceList.length <= 0) {
        vm.publics.message.danger('正在加载中，请稍后再试！');
        return false;
      }

      vm.note = vm.info.note;
      vm.provinceList.forEach((v1, k1) => {
        //  console.log(vm.info.province_id,v1.value)
        if (vm.info.province_id && vm.info.province_id == v1.value) {
          console.log(v1)
          vm.province_id = v1.value;
          vm.province_title = v1.label;
          vm.address_value[0] = v1.value;
          v1.children.forEach((v2, k2) => {
            if (vm.info.city_id && vm.info.city_id == v2.value) {
              console.log(vm.info.city_id)
              vm.city_id = v2.value;
              vm.city_title = v2.label;
              vm.address_value[1] = v2.value;
              v2.children.forEach((v3, k3) => {
                if (vm.info.district_id && vm.info.district_id == v3.value) {
                  console.log(vm.info.district_id)
                  vm.district_id = v3.value;
                  vm.district_title = v3.label;
                  vm.address_value[2] = v3.value;
                }
              });
            }
          });
        }
      })
      vm.address_full = vm.province_title + vm.city_title + vm.district_title;

      vm.service_id = vm.info.service_id;
      // console.log(vm.service_id)
      vm.getService();
    },
    submit() {
      let vm = this;
      // vm.successPopShow = true;
      // return;
      if (!(vm.district_id > 0)) {
        vm.publics.message.danger('请选择区域');
        return false;
      }
      if (vm.serviceList.length <= 0) {
        vm.publics.message.danger('所选区域未开通服务');
        return false;
      }
      if (!(vm.service_id > 0 && vm.service_title)) {
        vm.publics.message.danger('请选择服务商');
        return false;
      }
      if (!vm.note) {
        vm.publics.message.danger('请填写详细取件地址');
        return false;
      }
      let data = {
        service_id: vm.service_id,
        note: vm.note,
        province_id: vm.province_id,
        city_id: vm.city_id,
        district_id: vm.district_id
      }
      vm.ajax("account/parcel", "post", data, e => {
        vm.successPopShow = true;
        // vm.getInfo();
      })
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/parcel.vue